let labeltems = {
  modules: {
    pacnt: "Accounting",
  },
  page: {
    home: "Home",
    dashboard: "Dashboard",
    aboutUs: "About Us",
    contactUs: "Contact Us",
    baseInformation: "Base Informations",
    users: "Users",
    addUser: "AddNewUser",
    products: "Products",
    addProduct: "New Product",
    editProduct: "Edit Product",
    orders: "Orders",
    addOrder: "New Order",
    editOrder: "Edit Order",
    support: "Support",
    tickets: "Tickets",
    addTicket: "Open Ticket",
    messages: "Messages",
    profile: "Profile",
    login: "Sign In",
    register: "Sign Up",
    notFound: "Oops! Are You Lost ?!",
    notAccess: "Sorry! You Don't Have Access To This Page",
    noAccess: "No Access",
    serverError: "Internal Server Error! Please Call The Technical Support",
    underConstruction:
      "This Page is Under Construction and will be Available Soon",
    addCategory: "Add Category",
    search: "Search",
    userBranches: "User Branches",
    userGroups: "User Groups",
    userPermissions: "User Permissions",
    generalInfo: "General Information",
    financialInfo: "Business/Financial Information",
    taxFiles: "Tax Files",
    contacts: "Contacts",
    boardOfDirectors: "Board Of Directors",
  },
  menu: {
    home: "Home",
    dashboard: "Dashboard",
    about: "About Us",
    contact: "Contact Us",
    users: "Users",
    messages: "Messages",
    tickets: "Tickets",
    support: "Support",
    products: "Products",
    manageProducts: "Products Management",
    orders: "Orders",
    addOrder: "New Order",
    cart: "Cart",
    shop: "Shop",
    baseInformation: "Base Informations",
    reports: "Reports",
    editProfile: "Update Profile",
    notifications: "Notifications",
    allNotifications: "Show all Notifications",
    allMessages: "Show all Messages",
    logout: "Logout",
    rejectedTemplate: "Blocked Account",
    boardOfDirectors: "Board Of Directors",
  },
  button: {
    saltCalculation: "Salt Calculation",
    login: "Sign In",
    register: "Sign Up",
    logout: "Logout",
    recoveryEmail: "Send Recovery Email",
    submit: "Submit",
    submitInfo: "Submit Informations",
    save: "Save",
    saveInfo: "Save Informations",
    saveChanges: "Save Changes",
    editInfo: "Edit Information",
    add: "Add New",
    addUser: "New User",
    edit: "Update",
    delete: "Delete",
    confirmDelete: "Yes, Delete",
    editProfile: "Update Profile",
    editPassword: "Update Password",
    send: "Send",
    back: "Back",
    backToLogin: "Back to Login",
    backToHome: "Back to Home",
    home: "Home",
    cancel: "Cancel",
    addBase: "Add Base Info",
    reload: "Reload",
    addProduct: "Save Product",
    editProduct: "Update Profile",
    addChildCategory: "Add ChildCategory",
    addRow: "Add Row",
    editRow: "Update Row",
    clearForm: "Clear Form",
  },
  table: {
    baseDate: "Base Date",
    distanceDay: "Distance (Days)",
    timeWeight: "Time Weight",
    debtMinusCredit: "Debtor - Creditor",
    row: "#",
    actions: "Actions",
    title: "Title",
    qty: "Quantity",
    category: "Category",
    subject: "Subject",
    status: "Status",
    name: "Full Name",
    username: "Username",
    city: "City",
    role: "User Role",
    active: "Active",
    inactive: "Inactive",
    mainBranch: "Main Branch",
    taxId: "Tax ID",
    nationalCode: "National Code",
    sheetNumber: "Sheet No.",
    keyTypeTitle: "Key Type",
  },
  form: {
    stockInWare: "Stock in Warehouse",
    sourceStock: "Source Stock",
    destinationStock: "Destination Stock",
    draftRequestNo: "Draft Request No.",
    draftSerial: "Draft Serial",
    receiptSerial: "Receipt Serial",
    firstName: "First Name",
    lastName: "Last Name",
    fullName: "Full Name",
    userName: "Username",
    password: "Password",
    repeatPassword: "Repeat Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    email: "Email Address",
    mobile: "Mobile Number",
    tel: "Phone Number",
    phone: "Telephone",
    address: "Address",
    zipCode: "Zip Code",
    otpCode: "OTP Code",
    image: "Image",
    file: "File",
    fileSize: "Max File Size",
    fileType: "File Types",
    fileRatio: "Better To Use Square Ratio Picture",
    department: "Department",
    birthDate: "Birth Date",
    description: "Description",
    content: "Content",
    message: "Message",
    subject: "Subject",
    title: "Title",
    qty: "Quantity",
    digit: "Digit",
    category: "Category",
    city: "City",
    role: "User Role",
    productName: "Product Name",
    annualDemand: "Annual Demand",
    sbu: "SBU",
    resell: "Resell",
    weight: "Special Weight",
    sendDate: "Sent Date",
    productDate: "Production Date",
    paymentMethod: "Payment Method",
    cashOption: "Cash",
    chequeOption: "Cheque",
    attachment: "Attachment",
    dropzoneTxt: "Click or Drop File here",
    taxId: "Tax ID",
    roles: "Users Roles",
    validityDate: "Validity Date",
    personCode: "Person Code",
    personName: "Person Name",
    bank: "Bank",
    accountNumber: "Account Number",
    bankCardNumber: "Bank Card Number",
    shabaNumber: "Shaba Number",
    commission: "Commission",
    maxCountOrder: "Maximum number of orders",
    score: "Score",
    keyTypeTitle: "Key Type",
  },
  caption: {
    quickRegisterForLead: "for lead",
    quickRegisterForChance: "for opportunity",
    quickRegisterForProject: "for project",
    quickRegisterForTask: "for task",
    quickRegisterForCall: "for call",
    quickRegisterForMeeting: "following meeting",
    quickRegisterForContract: "for contract",
    manageFormFields: "Manage form fields",
    amountCalculation: "Amount calculation",
    itemFeatures: "Features",
    insuranceAndTax: "Insurance and tax",
    insuranceSection: "Insurance",
    taxSection: "Tax",
    accountParties: "Account parties",
    templateSelect: "Select template",
    descriptionPreview: "Voucher description preview",
    templateParts: "Description parts",
    emptyTemplateParts: "No parts defined for this template yet; add the first field.",
    selectTemplateFirst: "Select a template to view and edit its description parts.",
    templateField: "Description field",
    dragPartToReorder: "Drag and drop a row to change the order",
    allFieldsUsed: "All fields are already used in this template",
    savingOrder: "Saving order...",
    taxTableTypeHint: "Tax rate type cannot be selected in tiered mode.",
    companyForm: {
      basicInfo: "Company basic information",
      basicInfoDesc: "Name, type and field of activity",
      managerInfo: "Manager information",
      managerInfoDesc: "Details of the company manager",
      registerInfo: "Registration & tax information",
      registerInfoDesc: "Economic code, national ID and registration details",
      subscriptionInfo: "Subscription & access",
      subscriptionInfoDesc: "Validity, capacity, route and subsystems",
      contactInfo: "Contact information",
      contactInfoDesc: "Contact channels and address",
      images: "Images",
      imagesDesc: "Logo and icon shown in the system",
      logoHint: "PNG or JPG, preferably square",
      faviconHint: "PNG or ICO, 64×64 px",
      selectImage: "Select or drop an image",
      changeImage: "Change image",
      removeImage: "Remove image",
      uploading: "Uploading...",
    },
    accountTrend: "Account trend",
    noAccountSelected: "No account selected yet",
    noItemSelected: "No item selected yet",
    pbankDashboardHelp:
      "To see the last 30 days trend, click the desired slice in the pie charts.",
    saltCalculation: "Salt Calculation",
    saltBase: "Salt Basis",
    salt: "Salt",
    saltDetails: "Show Calculation Details",
    saltRowWithoutEffectiveDate:
      "This row has no effective date; its voucher date was used as the base date",
    saltEffectiveDateFallback:
      "{count} of {total} selected rows had no effective date, so their voucher date was used instead.",
    saltRowsNotFound:
      "{count} of {total} selected rows were not found. Please run the report again.",
    total: "Total",
    aggregateVoucherDetail: "Aggregate voucher details",
    aggregateByDebtAndCreditRemain: "Aggregate by debit and credit balance",
    aggregateRefreshConfirm:
      "Changing the aggregation option reloads the detail list from the server and discards your manual edits. Continue?",
    missingAccountRows: "Please select an account for rows without one.",
    yes: "Yes",
    no: "No",
    ok: "Ok",
    dashboard: "Dashboard",
    profile: "Update Profile",
    password: "Change Password",
    avatar: "Profile Avatar",
    baseInformation: "Basic Informations",
    addBaseInformation: "Add Basic Info",
    editBaseInformation: "Update Basic Info",
    users: "Users Management",
    addUser: "New User",
    editUser: "Update User",
    products: "Products Management",
    orders: "Manage Orders",
    messages: "Messages and Chats",
    tickets: "Tickets",
    loading: "Loading ...",
    singIn: "Sign in",
    singUp: "Sign Up",
    haveAccount: "Do you have Account ?",
    haveNotAccount: "Don't have Account ?",
    forgotPassword: "Forgot Password ?",
    emptyItem: "Item Not Found",
    emptyMessage: "There is no Message",
    emptyTicket: "There is no Tickets",
    emptyNotify: "There is no new Notifications",
    noMessage: "There is no new Message",
    noNotify: "There is no new Notification",
    underConstruction:
      "This Section is Under Construction and will be available soon",
    rejectedTitle: "No Access",
    rejectedText: "Your Account has been blocked or Reported",
    search: "Search",
    searchTable: "Search Items",
    searchAllColumns: "Search in all columns",
    delConfirm: "Are you sure you want to delete this item ?",
    resell: "is this Item for Resell ?",
    delConfirmPartOne: "Are you sure you want to delete the",
    areYouSure: "?",
    voucherTemplateFilters: "Template Filters",
    addVoucherTemplate: "New Voucher Template",
    voucherTemplateEntity: "voucher template",
    selectSubSystemAndVoucherType:
      "Select a subsystem and a voucher type to see the list",
    firstSelectSubSystem: "Select a subsystem first",
    firstSelectVoucherType: "Select a voucher type first",
    workspaceTitle: "Select workspace",
    workspaceDescription: "Choose the branch and fiscal year to sign in to.",
    currentBranch: "Current branch",
    fiscalYear: "Fiscal year",
    fiscalYearCount: "fiscal years",
    noFiscalYear: "No fiscal year has been defined for this branch",
    enterSystem: "Enter",
    version: "Version",
    companyName: "Parsina Pardazan Arya Co.",
    forgotPasswordTitle: "Forgot password",
    forgotPasswordDescription:
      "Enter the email registered on your account and we will send you a recovery link.",
    mitaOwnership:
      "Mita is a product of Parsina Pardazan Arya Co. All rights reserved.",
    mitaTitle: "Mita",
    loginHeadline1: "Integrated management,",
    loginHeadline2: "easy growth",
    changeTheme: "Change theme",
    loginDescription: "Enter your username and password to sign in.",
    usernamePlaceholder: "Username or personnel code",
    rememberMe: "Remember me",
    forgotPasswordLink: "Forgot password?",
    loginSlide1Title: "More than software",
    loginSlide1Desc: "For organizations that value accuracy and speed",
    loginSlide2Title: "Smart management",
    loginSlide2Desc: "Fast decisions with accurate data",
    loginSlide3Title: "Scalable and secure",
    loginSlide3Desc: "Ready to grow with your organization",
  },
  // Market items (Parsina panel) - tgju price widget tree
  marketItemManager: {
    intro:
      "Market symbol tree for the Mita price widget; every company sees this same tree. Mita users pick symbols only, folders are for grouping.",
    reload: "Refresh",
    addRoot: "Add",
    addFolder: "New folder",
    rootTitle: "Market symbols",
    addChild: "Add child",
    search: "Search title or widget code",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    expand: "Expand",
    collapse: "Collapse",
    folders: "folders",
    leaves: "symbols",
    childCount: "{count} children",
    emptyFolder: "Empty folder",
    hiddenInMita: "No symbols; hidden in Mita",
    loadFailed: "Could not load market items",
    editorLoadFailed: "Could not load this node",
    retry: "Retry",
    empty: "No market items yet",
    emptyHint: "Use the form beside to create the first folder or symbol, e.g. a \"Gold market\" folder.",
    noResult: "No node matches this search",
    moveUp: "Move up",
    moveDown: "Move down",
    reorderHint: "Use the arrows on each row to reorder; it saves right away",
    reorderDisabledSearch: "Clear the search to reorder",
    reorderSaved: "Order saved",
    unsaved: "Unsaved",
    selectTitle: "Select a node",
    selectHint: "Click a node in the tree to edit it, or create a new one.",
    newTitle: "New node",
    newIn: "in \"{title}\"",
    newInRoot: "at root",
    folder: "Folder",
    leaf: "Symbol",
    kind: "Type",
    kindFolderHint: "Only for grouping; it cannot be selected.",
    kindLeafHint: "Mita users select it to show its price widget; it cannot have children.",
    kindLocked: "This folder has children and cannot become a symbol.",
    sectionInfo: "Details",
    sectionPlace: "Position in tree",
    title: "Title",
    titleRequired: "Enter a title",
    titleMax: "At most 200 characters",
    titleDuplicate: "Another node at this level has the same title",
    code: "Widget code",
    codeRequired: "Enter the symbol's widget code",
    codeInvalid: "Widget code must be a whole number greater than zero",
    codeDuplicate: "This code is already used by \"{title}\"",
    codeHint: "The item_id field from tgju, not id. \"Search tgju\" is safer.",
    findCode: "Search tgju",
    parent: "Parent",
    parentRoot: "Root (no parent)",
    parentHint: "Only folders can be parents.",
    priority: "Display priority",
    priorityHint: "Lower numbers show first; ties are sorted by title.",
    priorityInvalid: "Priority must be a whole number",
    isDefault: "Default symbol",
    isDefaultHint: "Shown on the dashboard for users who have not picked any symbols.",
    defaultBadge: "Default",
    audit: "Created: {created} · {creator}",
    auditUpdate: "Last edit: {date} · {user}",
    save: "Save",
    create: "Create",
    saved: "Changes saved",
    created: "Node created",
    discard: "Revert",
    cancel: "Cancel",
    delete: "Delete",
    deleteLocked: "A node with children cannot be deleted; delete its children first.",
    deleteTitle: "Delete node",
    deleteText: "Delete \"{title}\"? This cannot be undone.",
    deleted: "Node deleted",
    unsavedTitle: "Unsaved changes",
    unsavedText: "Changes to \"{title}\" are not saved yet.",
    saveAndContinue: "Save and continue",
    dropChanges: "Don't save",
    stay: "Cancel",
    modeNew: "New",
    modeEdit: "Editing",
    editLeafNote: "This symbol already exists; picking another one from tgju changes this node's code and title, it does not create a new node.",
    addLeafIn: "Add a new symbol in \"{title}\"",
    addLeafInRoot: "Add a new symbol at root",
    finderTitle: "Pick a symbol from tgju",
    finderRoot: "tgju",
    finderSearch: "Search this level",
    finderFailed: "Could not load the tgju list",
    finderEmpty: "Nothing at this level",
    finderSelectRoot: "Pick a category",
    finderUsed: "Used by: {title}",
    finderPick: "Pick",
    finderHint: "Open folders to reach a symbol; the widget code is taken from its item_id.",
    close: "Close",
  },
  // Stimulsoft report management (Parsina panel)
  reportManager: {
    subSystem: "Subsystem",
    reportType: "Report type",
    reportTypeHint: "If it is not listed, enter the numeric code of the report type",
    title: "Report title",
    branch: "Branch",
    allBranches: "Whole organization",
    isDefault: "Default",
    isDefaultHint: "regular site users cannot design, rename or delete it",
    mrtFile: "Stimulsoft file (.mrt)",
    mrtReadFailed: "The Stimulsoft file is empty or could not be read",
    openDesignerAfterCreate: "Open the designer after saving",
    add: "New report",
    rename: "Rename",
    renameTitle: "Rename report",
    design: "Design",
    copy: "Copy",
    copyTitle: "Copy report",
    copySource: "Source report",
    copyHint: "The copy is created in the same branch as the source report",
    delete: "Delete",
    export: "Export selected reports",
    exportFailed: "Exporting the reports failed",
    import: "Import reports from file",
    importFile: "Reports export file (.json)",
    importHint: "Import is all or nothing; if one report is invalid nothing is saved",
    updateIfExist: "Update existing reports",
    updateIfExistHint:
      "A report on this server with the same id and type is replaced and the rest are added; otherwise all are added as new reports (without branch)",
    importResult: "Import result",
    importNew: "New",
    importUpdated: "Updated",
    entityName: "report",
    maxLength: "At most 100 characters",
  },
  // Menu management (Parsina panel)
  menuManager: {
    intro:
      "Set the title, icon, URL, order and permission of menus; changes show up in the portal once saved.",
    subSystem: "Subsystem",
    reload: "Refresh",
    search: "Search title, URL or permission",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    expand: "Expand",
    collapse: "Collapse",
    groups: "groups",
    items: "menus",
    childCount: "{count} submenus",
    loadFailed: "Couldn't load menus",
    editorLoadFailed: "Couldn't load this menu",
    retry: "Try again",
    empty: "This subsystem has no menus",
    noResult: "No menu matches this search",
    noUrl: "No URL",
    noUrlHint: "Menus without a URL are not shown in the portal",
    permissionFromChildren: "From submenus",
    permissionNotSet: "Not set",
    moveUp: "Move up",
    moveDown: "Move down",
    reorderHint: "Use the arrows on each row to reorder; changes save right away",
    reorderDisabledSearch: "Clear the search to reorder menus",
    reorderSaved: "Menu order saved",
    startPage: "Start page",
    startPageHint:
      "After login, the portal opens the first menu the user has access to",
    unsaved: "Unsaved",
    selectTitle: "Select a menu",
    selectHint: "Click a menu in the list to edit it.",
    group: "Group",
    item: "Menu",
    sectionAppearance: "Appearance",
    sectionBehavior: "URL and permission",
    title: "Title",
    titleRequired: "Enter a title",
    maxLength: "Up to 100 characters",
    icon: "Icon",
    iconPlaceholder: "dashboard",
    iconHint: "Material icon name or PrimeIcons (like pi-home)",
    iconUnknown: "The portal doesn't know this icon and shows a circle instead",
    iconNestedHint: "The portal menu only shows icons for top-level menus",
    pickIcon: "Browse",
    iconSearch: "Search icons",
    suggestedIcons: "Suggested icons",
    searchResults: "Results",
    moreResults: "{count} more icons; try a more specific search",
    noIcon: "No icons found",
    clearIcon: "No icon",
    url: "URL",
    urlPlaceholder: "/club/dashboard",
    urlHint: "Page path in the portal",
    urlSlash: "The URL must start with /",
    groupUrl: "Group menus have no URL; clicking one opens its submenus.",
    permission: "Permission",
    permissionPlaceholder: "Not set",
    permissionGroupHint:
      "Group menus usually have no permission and appear when a submenu is allowed",
    permissionReadonly:
      "Permissions of this subsystem's menus can't be changed here",
    preview: "Portal menu preview",
    previewHint: "Each user only sees the menus they have access to.",
    hiddenInPortal: "Hidden",
    save: "Save changes",
    saved: "Menu saved",
    discard: "Revert",
    unsavedTitle: "Unsaved changes",
    unsavedText: "Changes to “{title}” haven't been saved yet.",
    saveAndContinue: "Save and continue",
    dropChanges: "Discard changes",
    stay: "Stay",
  },
};

export default labeltems;
